import { FC } from 'react';

import { Box, rem } from '@bonusly/design-system';

import { ReferenceEntity } from '../../lib/entities/reference';
import { ReferencePreview } from '../reference';

interface Props {
	reference?: ReferenceEntity | null;
}

export const FeedbackReference: FC<Props> = ({ reference }) => {
	if (!reference) {
		return null;
	}

	return (
		// 40px avatar size + 16px column gap
		<Box pl={rem(40 + 16)} data-testid="feedback-reference">
			<ReferencePreview linkToReference reference={reference} />
		</Box>
	);
};
